// extracted by mini-css-extract-plugin
export default {"main":"NoteExpertInsidePage_main__iHRpN","emaillink":"NoteExpertInsidePage_emaillink__wD6Ru"};